<template>
  <div class="main_center" style="background-color:#F5F5F5;">
    <div class="content" style="background-color:#F5F5F5;border:none;">
      <searchBox :dialogVisible.sync="moreSearchItem" @dialogCancle="dialogCancle" title="更多筛选">
        <div class="search-drawer">
          <el-form :model="projectForm" label-position="top" ref="form">
            <!-- <el-row:span="5">
                                  <el-form-item label="受理状态: " props="receiveStatus">
                                    <el-select v-model="projectForm.receiveStatus" clearable @change="handleSearch" placeholder="请选择">
                                      <el-option
                                          v-for="item in processingStateList"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </el-row> -->
            <el-row>
              <el-form-item label="投诉编号: " props="complaintCode">
                <el-input @keyup.enter.native="handleSearch" clearable placeholder="请输入内容搜索"
                  v-model="projectForm.complaintCode"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="项目(标段)名称: " props="bidSectionName">
                <el-input @keyup.enter.native="handleSearch" clearable placeholder="请输入内容搜索"
                  v-model="projectForm.bidSectionName"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="数据所属部门：">
                <select-depart-tree ref="selectDepartTreeRef" :type="'2'"
                  :modelValue.sync="projectForm.superviseDeptCodeList" :isMultiple="true"
                  @handleDeptType="(val) => changeDept(val, '5')">
                </select-depart-tree>
              </el-form-item>
            </el-row>
          </el-form>
          <div class="search-drawer__footer">
            <el-button @click="handleSearch" size="small" type="primary">搜索</el-button>
            <el-button @click="handleRefresh" plain size="small">刷新</el-button>
          </div>
        </div>
      </searchBox>

      <div class="punish-info-tabs">
        <div class="online_top">
          <div class="pageTitle">投诉信息</div>
          <div class="searchBtn centerSearch">
            <el-input class="my_input" placeholder="请输入项目名称/投诉编号" v-model="projectForm.bidSectionNameOrCode"
              @keyup.enter.native="handleSearch" style="width: 525px" clearable></el-input>
            <el-button type="primary" size="small" @click="handleSearch" class="rightSearchBtn">搜索</el-button>
            <el-button @click="moreSearchItem = true" icon="el-icon-arrow-down" size="mini" type="text"
              class="height_four">更多搜索</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="handleRefresh" icon="el-icon-refresh" type="text" class="height_four"></el-button>
          </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :name="item.name" v-for="(item, index) in tabPaneList" :key="index">
            <el-badge slot="label" :is-dot="item.dot" class="item">
              <span>{{ item.label }}</span>
            </el-badge>
          </el-tab-pane>

        </el-tabs>
      </div>
      <div class="tableContent_">
        <exceptiontable ref="exceptiontable" v-if="activedTab == 'exception'" :tableHeight="tableHeight"
          :search="projectForm.bidSectionNameOrCode"></exceptiontable>
        <otherhandletable ref="otherhandletable" v-else :activedTab="actived" :tableHeight="tableHeight"
          :filterStatus="projectForm.receiveStatus" :search="projectForm.bidSectionNameOrCode"
          :filterParams="filterParams"></otherhandletable>
        <div style="overflow-x:hidden;">
          <div class="statisticalChart">
            <div class="bgAnimateBox">
              <div class="bgAnimate">
                <div></div>
                <div></div>
              </div>
              <div class="bgAnimate">
                <div></div>
                <div></div>
              </div>
            </div>
            <div class="com_title">投诉统计</div>
            <el-button size="mini" type="text" v-if="!moreItem" @click="openBox">展开投诉统计
            </el-button>
            <el-button size="mini" type="text" v-if="moreItem" @click="openBox">折叠投诉统计
            </el-button>
            <div class="Chart" v-if="moreItem">
              <complainantStatistics :superviseDeptCodeList="projectForm.superviseDeptCodeList"></complainantStatistics>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import complainantStatistics from './components/complainant_statistics';
import ExceptionTable from "./components/exceptionList"
import OtherHandleTable from "./components/otherHandleList"
import { getTabCount } from "@/server/complaint"
import selectDepartTree from "@/views/modules/components/selectDepartTree"
import { mapState } from "vuex";
export default {
  name: "onlineTable",
  data() {
    let filterParams = {};
    if (this.$route.query && this.$route.query.dateRange) {
      let currentDate = new Date(); // 获取当前日期
      currentDate.setDate(currentDate.getDate() - this.$route.query.dateRange); // 将当前日期减去30天
      let previousDate = currentDate.toISOString().split('T')[0];
      filterParams = {
        submitTimeGE: (new Date()).toISOString().split('T')[0] + " " + new Date().toLocaleTimeString(),
        submitTimeLE: previousDate + " 00:00:00",
      };
    }

    return {
      tableMaxHeight: document.documentElement.clientHeight - 667,
      tableHeight: document.documentElement.clientHeight - 667,
      dataListLoading: false,
      moreSearchItem: false,
      projectForm: {
        bidSectionName: '',
        receiveStatus: 1,// 1 代表待受理
        complaintCode: '',
        bidSectionNameOrCode: '',
        superviseDeptCodeList: [],// 数据所属部门
      },
      moreItem: false,
      tableData: [],
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 8,//总条数
      processingStateList: [
        { label: '已受理', value: 3 },
        { label: '待受理', value: 1 },
        { label: '不予受理', value: 2 },
      ],
      treatmentAgingList: [],
      animateWidth: document.body.clientWidth - 275,
      checkReceiveStatus: [],
      checkReceiveOptions: [],
      checkEndStatus: [],
      checkOwerDeptHandleResult: [],
      checkLastHandleStatus: [],
      checkEndStatusOptions: [],
      activeName: "waitAccept",
      tabPaneList: [{ name: 'waitAccept', label: '待受理', dot: false },
      { name: 'pending', label: '待处理', dot: false },
      { name: 'processed', label: '已处理', dot: false },
      { name: 'exception', label: '异常处理', dot: false },
      { name: 'all', label: '全部', dot: false }],
      activedTab: "waitAccept",
      actived: 'waitAccept',

      dateRange: undefined,
      filterParams,
    }
  },
  components: {
    complainantStatistics,
    exceptiontable: ExceptionTable,
    otherhandletable: OtherHandleTable,
    selectDepartTree
  },
  watch: {
    activedTab: {
      handler(val) {
        this.actived = val;
        if (this.actived == 'waitAccept') {//待受理
          this.projectForm.receiveStatus = 1
        }
        else if (this.actived == 'pending') {//待处理
          this.projectForm.receiveStatus = 2
        } else if (this.actived == 'processed') {//已处理
          this.projectForm.receiveStatus = 3
        } else if (this.actived == 'exception') {//异常处理
          this.projectForm.receiveStatus = 4
        } else if (this.actived == 'all') {//全部
          this.projectForm.receiveStatus = 5
        }
      },
    },
    uerdefultOptionCode: {
      handler(val) {
        if (val.length !== 0) {
          this.uploadComList()
        }
      }
    },
    tableMaxHeight: {
      handler(val) {
        this.tableHeight = val
      }
    },
  },
  computed: {
    ...mapState({
      // 数据所属部门 默认值
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
      tradingCenterOption: state => { return state.dataDictionary.tradingCenterOption; },
    }),
  },
  mounted() {
    this.setQueryData();
    this.$store.dispatch('dataDictionary/getComplaintMatterAtt');//获取抽取结果录入附件配置项数据
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.getWidth();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    this.getWidth();
  },
  activated() {
    this.setQueryData();
    // 获取tab是否展示红点
    this.getTabViewdot()
  },
  methods: {
    setQueryData() {
      if (this.$route.query && this.$route.query.dateRange) {
        this.dateRange = this.$route.query.dateRange;
        let currentDate = new Date(); // 获取当前日期
        currentDate.setDate(currentDate.getDate() - this.$route.query.dateRange); // 将当前日期减去30天
        let previousDate = currentDate.toISOString().split('T')[0];
        this.filterParams = {
          submitTimeGE: (new Date()).toISOString().split('T')[0] + " " + new Date().toLocaleTimeString(),
          submitTimeLE: previousDate + " 00:00:00",
        };
      } else {
        this.filterParams = {};
      }
      // 获取参数 判断是由哪个tab的详情页
      this.activeName = this.$route.query.tabActived || 'waitAccept'
      this.activedTab = this.activeName
    },
    changeDept(val, str) {//切换部门
      this.projectForm.superviseDeptCodeList = []
      if (str === '5') {
        // 多选
        val.forEach((item, index) => {
          if (item.type !== "region") {
            this.projectForm.superviseDeptCodeList.push(item.code)
          }
        })
      }
    },
    getTabViewdot() {
      getTabCount().then((res) => {
        if (res.data.code == 1) {
          let dataInfo = res.data.data || []
          dataInfo.forEach((item, index) => {
            if (item.code == "A") {
              this.tabPaneList[0].dot = item.needProcessed
            }
            if (item.code == "B") {
              this.tabPaneList[1].dot = item.needProcessed
            }
            if (item.code == "C") {
              this.tabPaneList[3].dot = item.needProcessed
            }
          })
        }
      })
    },
    handleClick(tab) {
      this.activedTab = tab.name
      if (this.activedTab == 'waitAccept') {//待受理
        this.projectForm.receiveStatus = 1
      }
      else if (this.activedTab == 'pending') {//待处理
        this.projectForm.receiveStatus = 2
      } else if (this.activedTab == 'processed') {//已处理
        this.projectForm.receiveStatus = 3
      } else if (this.activedTab == 'exception') {//异常处理
        this.projectForm.receiveStatus = 4
      } else if (this.activedTab == 'all') {//全部
        this.projectForm.receiveStatus = 5
      }
      this.projectForm.bidSectionNameOrCode = ''
    },
    getWidth() {
      // let hasBtnPermisson = this.hasBtnPermission("online_complaints_btn_add");
      let tableMaxHeight = (document.documentElement.clientHeight - 325);
      this.$nextTick(() => {
        this.animateWidth = document.body.clientWidth - 275;
        this.tableMaxHeight = tableMaxHeight
        this.$forceUpdate();
        // // 创建style标签
        // const style = document.createElement('style');
        // // 设置style属性
        // style.type = 'text/css';
        // // 将 keyframes样式写入style内
        // style.innerHTML = runkeyframes;
        // // 将style样式存放到head标签
        // document.getElementByTagName('head')[0].appendChild(style);

        let style = document.styleSheets;
        if (style) {
          style[0].insertRule("@keyframes toRight {from{left:-" + this.animateWidth + "px;}100%{left:0px;}}")
          style[0].insertRule("@keyframes toLeft {from{left:0px;}100%{left:-" + this.animateWidth + "px;}}")
        }
      });
    },
    dialogCancle() {
      this.moreSearchItem = false
    },
    //搜索按钮
    handleSearch() {
      this.moreSearchItem = false
      if (this.projectForm.receiveStatus == '') {
        this.projectForm.receiveStatus = null
      }
      this.pageIndex = 1;
      this.uploadComList()
    },
    uploadComList() {
      switch (this.projectForm.receiveStatus) {
        case 1:
        case 2:
        case 3:
        case 5:
          this.$refs.otherhandletable.getDataList('1', this.projectForm); break;
        case 4: this.$refs.exceptiontable.getDataList('1', this.projectForm); break;
        default: break;
      }
    },
    handleRefresh() {//刷新按钮
      this.moreSearchItem = false
      this.pageIndex = 1;
      this.projectForm.bidSectionName = "";
      this.projectForm.complaintCode = '';
      this.projectForm.bidSectionNameOrCode = ''
      this.projectForm.superviseDeptCodeList = this.uerdefultOptionCode
      // 重置默认所属数据
      if (this.$refs.selectDepartTreeRef) {
        this.$refs.selectDepartTreeRef.getUserTreeOption()
      }
      this.uploadComList()
    },
    formatterStatusClass(historyId) {
      switch (historyId) {
        case 3: return 'icon-point icon-point-success'; break;
        case 1: return 'icon-point icon-point-verificationing'; break;
        case 2: return 'icon-point icon-point-danger'; break;
        default: return ''; break;
      }
    },
    openBox() {
      this.moreItem = !this.moreItem;
      let tableMaxHeight;
      if (this.moreItem == true) {
        // setTimeout(() => {
        //   document.documentElement.scrollTop=document.documentElement.scrollHeight-100
        // }, 500);
        tableMaxHeight = document.documentElement.clientHeight - 540;
      } else {
        tableMaxHeight = (document.documentElement.clientHeight - 325);
      }
      this.tableMaxHeight = tableMaxHeight


    },

  }
}
</script>
<style lang="scss">
.punish-info-tabs {
  .centerSearch {

    .el-input .el-input__inner,
    .el-input--medium .el-input__inner,
    .el-input--suffix .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    .rightSearchBtn {
      height: 40px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    .height_four {
      height: 40px;
    }

    .el-input--medium .el-input__inner {
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
<style lang="scss" scoped>
.main_center {
  background: #fff;

  .statisticalChart {
    position: relative;
    height: auto;

    .bgAnimateBox {
      position: relative;
      height: 90px;
      overflow: hidden;
    }

    .bgAnimate {
      display: flex;
      position: absolute;
      top: 10px;
      height: 186px;
      width: 200%;

      &:nth-of-type(1) {
        animation: toRight 30s infinite linear;

        &>div {
          background-image: url('../../../../assets/img/ripple.png');
        }
      }

      &:nth-of-type(2) {
        animation: toLeft 25s infinite linear;

        &>div {
          background-image: url('../../../../assets/img/ripple1.png');
        }
      }

      &>div {
        width: 50%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

    }

    // background: linear-gradient(180deg, rgba(53, 195, 255, 0.1) 0%, rgba(24, 144, 255, 0) 100%);
    color: #fff;
    position: relative;

    .com_title {
      position: absolute;
      left: 15px;
      top: 40px;
      font-size: 18px;
      font-weight: 600;
      color: #1890ff;
    }

    .el-button--text {
      position: absolute;
      top: 40px;
      right: 28px;
      width: 108px;
      height: 32px;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px 0px rgba(72, 92, 109, 0.2);
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #1890FF;
      line-height: 22px;
      cursor: pointer;
    }

    .el-icon-close {
      position: absolute;
      top: 19px;
      right: 28px;
      width: 40px;
      height: 40px;
      color: #000;
      cursor: pointer;
    }

    .Chart {
      width: 100%;
      height: 225px;
      background: linear-gradient(180deg, rgba(242, 250, 255, 1) 0%, rgba(24, 144, 255, 0) 100%);

    }
  }

}

.punish-info-tabs {
  padding: 0 24px;
  padding-top: 24px;
  position: relative;
  background: #ffffff;

  .online_top {
    display: flex;
    align-items: center;
  }

  .pageTitle {
    font-size: 18px;
    font-weight: 600;
    color: #000000;
    height: 40px;
  }

  /deep/.el-badge__content.is-fixed.is-dot {
    right: 0px;
    top: 10px;
  }

  .searchBtn {
    width: calc(100% - 80px);
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
  }

}

// @keyframes toLeft {from{left:0px;}100%{left:-1660px;}}
// @keyframes toRight {from{left:-1660px;}100%{left:0px;}}</style>
